import { styled } from '@linaria/react'
import theme from '../theme';

const Button = styled.button`
    border-radius: 5px;
    padding: 10px;

    background-color: ${theme.color.white.main};
    border: none;

    &:hover {
        box-shadow: ${theme.boxShadow.medium};
    }
`;

export default Button;
